import AppPage from '../common/AppPage';
import { useSearchParams } from 'react-router-dom';
import MapCanvas from './MapCanvas';

function MapPage() {
  const [searchParams] = useSearchParams();
  const roomIdParam = searchParams.get('roomId');
  const initialRoomId = roomIdParam ? parseInt(roomIdParam) || 0 : 0;

  return (
    <AppPage pageClass="map-page">
      <div className="map">
        <h5 style={{marginBottom: '1.125rem'}}>WoTMud Map</h5>
        <MapCanvas initialRoomId={initialRoomId}/>
      </div>
    </AppPage>
  );
}

export default MapPage;